import Clarity from '@microsoft/clarity'
import * as Sentry from '@sentry/react'
import { QueryClientProvider } from '@tanstack/react-query'
import { ErrorFallback, initSentry } from '@viapeople/components'
import '@viapeople/components/src/tailwind.config.css'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { router } from './Routes.tsx'
import { ToastProvider } from './utils/ToastContext.tsx'
import { queryClient } from './utils/trpc'
import './global.css'

initSentry({
	dsn: import.meta.env.VITE_CLIENT_SENTRY_DSN,
	environment: import.meta.env.VITE_ENVIRONMENT || 'local',
	appName: 'client',
	release: import.meta.env.VITE_SENTRY_RELEASE,
})

if (import.meta.env.VITE_ENVIRONMENT === 'prod') {
	Clarity.init('vjycq17ie6')
}

createRoot(document.getElementById('root') as HTMLElement).render(
	<Sentry.ErrorBoundary fallback={<ErrorFallback />}>
		<StrictMode>
			<QueryClientProvider client={queryClient}>
				<ToastProvider>
					<RouterProvider router={router} />
				</ToastProvider>
			</QueryClientProvider>
		</StrictMode>
	</Sentry.ErrorBoundary>,
)
